export enum ViewReferer {
  ad = 'ad',
  external = 'external',
  unknown = 'unknown',
  mentor = 'mentor',
}
